import React, { useEffect, useState } from 'react';
import { Link } from "react-router";
import ReactDOM from "react-dom";
import '../CSS/styles.css';
import Top from './Top';
import AOS from 'aos';
import 'aos/dist/aos.css';

const OffcanvasMenu = ({ id, labelledby, children, show, onHide }) => {
  return ReactDOM.createPortal(
    <div
      className={`offcanvas offcanvas-end custom-offcanvas ${show ? "show" : ""
        }`}
      tabIndex={-1}
      id={id}
      aria-labelledby={labelledby}
      onTransitionEnd={(e) => {
        if (!show && e.propertyName === "transform") {
          onHide();
        }
      }}
    >
      {children}
    </div>,
    document.body
  );
};

const Hnavbar = () => {

  const [atTop, setAtTop] = useState(true);
  const [isSmallDevice, setIsSmallDevice] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const onScroll = () => {
      setAtTop(window.scrollY === 0);
    };

    const onResize = () => {
      setIsSmallDevice(window.innerWidth <= 600);
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);

    onResize();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const navbarStyle = {
    marginTop: atTop ? (isSmallDevice ? '140px' : '90px') : '0px',
    transition: 'margin-top 0.3s ease',
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const openOffcanvas = () => setShowOffcanvas(true);
  const hideOffcanvas = () => setShowOffcanvas(false);

    useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  const primaryNavLinks = (
    <>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3 active"
          to="/Home"
          onClick={hideOffcanvas}
        >
          Home
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3"
          to="/About"
          onClick={hideOffcanvas}
        >
          About Us
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3"
          to="/Services"
          onClick={hideOffcanvas}
        >
          Services
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3"
          to="/Projects"
          onClick={hideOffcanvas}
        >
          Projects
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3"
          to="/News"
          onClick={hideOffcanvas}
        >
          News & Blogs
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className="nav-link fs-6-5 mx-lg-3"
          to="/Contact"
          onClick={hideOffcanvas}
        >
          Contact Us
        </Link>
      </li>
    </>
  );

  return (
    <>
      <Top />
      <div className="inter fw-medium urb">
        <nav className="navbar navbar-expand-lg bs fixed-top py-4 wcc" style={navbarStyle} data-aos="fade-up"> 
          <div className="container d-flex align-items-center justify-content-between">
            <Link className='text-decoration-none' to="/Home">
              <svg width="207" height="39" viewBox="0 0 207 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_13_624)">
                  <path d="M162.079 0H0.600708V38.7397H162.079V0Z" fill="#2C2F76" />
                  <path d="M189.272 0L187.179 1.7609L185.086 0H167.78L172.639 6.35454H181.677L184.444 8.40636V37.8899L183.588 38.5253V39H187.179H190.771V38.5253L189.915 37.8899V8.40636L192.682 6.35454H201.72L206.579 0H189.272Z" fill="#BFBFBF" />
                  <path d="M177.309 8.98828H171.744V38.9924H177.309V8.98828Z" fill="#BCBEC0" />
                  <path d="M202.711 8.98828H197.145V38.9924H202.711V8.98828Z" fill="#BCBEC0" />
                  <path d="M6.98279 13.8038C7.66054 13.7208 8.31348 13.5045 8.90136 13.1684C9.38066 12.8744 9.77593 12.469 10.0509 11.9893C10.3581 11.4211 10.5771 10.8123 10.701 10.1825C10.8596 9.45518 11.0261 5.2367 11.2005 3.85095H14.562V12.6631H22.2125V14.9599H14.562V25.1348C14.5445 26.3141 14.6081 27.4931 14.7523 28.6643C14.826 29.3929 15.067 30.0964 15.4579 30.7237C15.7521 31.172 16.1619 31.5387 16.6471 31.7879C17.1816 32.0216 17.7652 32.1317 18.3516 32.1095C18.9651 32.1139 19.5719 31.9857 20.1275 31.7343C20.7241 31.4512 21.2743 31.0849 21.7606 30.6472L22.823 31.8798C21.8971 32.8012 20.827 33.5762 19.6518 34.1766C18.6833 34.64 17.617 34.8811 16.5361 34.881C14.4959 34.881 12.979 34.2991 11.9854 33.1354C10.9944 31.9717 10.4949 30.1419 10.4949 27.6613V14.9752H6.99068L6.98279 13.8038Z" fill="#BFBFBF" />
                  <path d="M38.3541 31.2597L38.0053 31.1678C36.8901 32.3314 35.5795 33.3047 34.1285 34.0465C32.9307 34.6086 31.615 34.8967 30.2834 34.8887C29.1856 34.9131 28.0979 34.682 27.1121 34.2149C26.227 33.8018 25.492 33.14 25.0033 32.3162C24.4995 31.4582 24.2448 30.4849 24.266 29.4988C24.266 27.2683 25.4076 25.5483 27.6909 24.3386C29.9742 23.129 33.3911 22.4169 37.9577 22.2255V20.6943C38.0017 19.4301 37.8412 18.167 37.482 16.9505C37.2413 16.1331 36.7145 15.4215 35.9916 14.937C35.1664 14.4715 34.2188 14.2481 33.2643 14.2939C32.1872 14.2447 31.129 14.5799 30.2913 15.2356C29.4608 15.9962 28.8745 16.9716 28.6026 18.0453H25.4948V15.0748C26.7216 14.4399 27.9871 13.8774 29.2844 13.3904C30.273 13.0359 31.2881 12.7543 32.3209 12.5483C33.3321 12.3401 34.3631 12.2349 35.397 12.2344C36.6935 12.1828 37.9843 12.4294 39.1628 12.954C40.1118 13.4381 40.8634 14.2179 41.2954 15.1666C41.8492 16.5964 42.0921 18.121 42.009 19.6454V27.6078C42.009 28.7332 42.009 29.5294 42.009 29.9964C42.0144 30.4282 42.0595 30.8586 42.1437 31.2827C42.1979 31.6184 42.3191 31.9408 42.5005 32.232C42.6777 32.4882 42.9172 32.6985 43.1982 32.8445C43.6785 33.072 44.1837 33.2467 44.7045 33.3651V34.4906H38.2273L38.3541 31.2597ZM37.9577 24.1013C34.7865 24.1013 32.3526 24.5377 30.7591 25.3339C30.0387 25.6373 29.4279 26.1407 29.0044 26.78C28.5809 27.4193 28.3638 28.1658 28.3807 28.9246C28.341 29.6489 28.5319 30.3676 28.9277 30.9841C29.2583 31.4634 29.7388 31.8282 30.2992 32.0253C30.9329 32.2282 31.598 32.3241 32.2654 32.3086C33.2948 32.3173 34.3068 32.0524 35.1908 31.543C36.0278 31.0771 36.731 30.4165 37.2363 29.6213C37.6984 28.9368 37.9537 28.1414 37.9736 27.3245L37.9577 24.1013Z" fill="#BFBFBF" />
                  <path d="M56.335 16.1849L56.6679 16.2768C57.4011 15.543 58.1794 14.8527 58.9988 14.2096C59.5462 13.7802 60.1357 13.4032 60.7588 13.0842C61.2623 12.826 61.7941 12.6231 62.3444 12.4793C62.8445 12.3566 63.3585 12.2949 63.8745 12.2956C65.246 12.235 66.6008 12.6057 67.7354 13.3521C68.7971 14.1548 69.5256 15.2984 69.7888 16.5753C70.6938 15.6653 71.6548 14.8088 72.6667 14.0106C73.3556 13.4924 74.1128 13.065 74.9183 12.7397C75.7065 12.4426 76.5457 12.292 77.3919 12.2956C78.3244 12.2763 79.2523 12.4269 80.127 12.7397C80.8862 13.0304 81.5552 13.505 82.0694 14.1177C82.631 14.7894 83.0293 15.5743 83.2348 16.4146C83.5111 17.6465 83.6335 18.906 83.5995 20.166V28.7868C83.579 29.5898 83.6188 30.3932 83.7184 31.1908C83.7692 31.5493 83.8846 31.8965 84.0593 32.2167C84.2283 32.4753 84.4595 32.6907 84.7332 32.8445C85.2148 33.0852 85.7264 33.2653 86.2554 33.3804V34.5058H76.9479V33.3804C77.4018 33.257 77.8445 33.0983 78.2719 32.9057C78.5401 32.7681 78.7709 32.5714 78.9457 32.3315C79.1682 31.9866 79.314 31.6007 79.3739 31.1984C79.4927 30.4385 79.5431 29.67 79.5245 28.9016V22.9069C79.5245 21.613 79.5245 20.5412 79.4214 19.699C79.378 19.014 79.2664 18.3346 79.0884 17.6701C78.9757 17.248 78.7908 16.8469 78.5414 16.4835C78.3373 16.1984 78.0947 15.9409 77.82 15.7179C77.5399 15.4973 77.2201 15.3286 76.8765 15.2202C76.4064 15.0834 75.9164 15.0213 75.4257 15.0365C74.8191 15.0337 74.219 15.1564 73.6657 15.3963C73.009 15.7157 72.4095 16.1344 71.8898 16.6366C71.3168 17.1282 70.846 17.7206 70.5024 18.3822C70.2032 19.0349 70.057 19.7434 70.0742 20.457V28.8021C70.0538 29.6051 70.0935 30.4086 70.1932 31.2061C70.2456 31.5653 70.3637 31.9127 70.542 32.232C70.7068 32.4939 70.9389 32.7102 71.2159 32.8598C71.694 33.102 72.2032 33.2822 72.7302 33.3957V34.5212H63.4385V33.3957C63.8928 33.2737 64.3357 33.115 64.7624 32.921C65.0306 32.7834 65.2615 32.5867 65.4363 32.3468C65.6588 32.0019 65.8046 31.616 65.8644 31.2137C65.9867 30.4541 66.0398 29.6855 66.023 28.9169V22.9222C66.023 21.5671 65.9754 20.4646 65.9041 19.6071C65.8523 18.9103 65.7274 18.2202 65.5315 17.5477C65.3962 17.0971 65.1817 16.6724 64.8972 16.2921C64.677 15.9976 64.4094 15.7391 64.1044 15.5265C63.81 15.3533 63.4889 15.2266 63.1531 15.1513C62.7498 15.0645 62.3374 15.0234 61.9242 15.0288C61.29 15.0236 60.664 15.1682 60.1008 15.4499C59.4638 15.7789 58.8769 16.1911 58.3566 16.6749C57.8084 17.1477 57.3544 17.7134 57.0168 18.3439C56.7203 18.9275 56.5683 19.5696 56.5728 20.2196V28.7944C56.5728 29.6596 56.5728 30.3256 56.6441 30.785C56.6705 31.1499 56.7452 31.5102 56.8661 31.8568C56.9509 32.0891 57.083 32.3025 57.2546 32.4846C57.4513 32.6728 57.679 32.828 57.9285 32.944C58.3511 33.1332 58.7919 33.2819 59.2445 33.3881V34.5135H49.9608V33.3881C50.4048 33.2659 50.8372 33.1071 51.2531 32.9134C51.5182 32.7716 51.7482 32.5756 51.927 32.3392C52.1538 32.0019 52.3 31.6201 52.3551 31.2214C52.4687 30.4404 52.5165 29.6518 52.4978 28.8633V18.9104C52.4978 17.9381 52.4978 17.1572 52.4502 16.56C52.4431 16.0657 52.3297 15.5781 52.1172 15.1283C51.9288 14.7849 51.6236 14.5145 51.2531 14.3627C50.7253 14.1456 50.1712 13.9938 49.604 13.911V12.7014L55.1536 12.4947H56.6045L56.335 16.1849Z" fill="#BFBFBF" />
                  <path d="M96.9503 16.2538H97.0455C97.8887 15.3673 98.812 14.5551 99.8044 13.8268C100.502 13.3439 101.265 12.955 102.072 12.6708C102.902 12.4006 103.773 12.266 104.649 12.2726C106.197 12.2314 107.719 12.6686 108.993 13.5206C110.287 14.4706 111.258 15.7713 111.784 17.2567C112.493 19.2241 112.826 21.2993 112.767 23.3816C112.832 25.5377 112.433 27.6835 111.593 29.6825C110.899 31.3009 109.688 32.6633 108.137 33.5718C106.491 34.4748 104.622 34.9274 102.73 34.881C101.62 34.8883 100.512 34.7856 99.4239 34.5748C98.2965 34.3399 97.2025 33.9749 96.1655 33.4876L94.5085 34.881L92.8753 34.5212V11.7061C92.8753 10.2438 92.8753 9.22552 92.8753 8.64366C92.8626 8.14626 92.7989 7.65131 92.6851 7.16605C92.6171 6.82416 92.4738 6.50038 92.2648 6.21669C92.0693 5.97953 91.816 5.79279 91.5275 5.67311C90.9902 5.47589 90.4318 5.33722 89.8627 5.25968V4.05002L95.5867 3.828H96.99L96.9503 16.2538ZM96.9503 26.2909C96.9348 27.2276 96.9904 28.1642 97.1169 29.093C97.1986 29.7054 97.3918 30.2989 97.6877 30.8463C97.9743 31.3341 98.3599 31.7612 98.8214 32.1019C99.3145 32.4718 99.8854 32.7331 100.494 32.8675C101.17 33.0213 101.862 33.0958 102.555 33.0895C103.416 33.1271 104.271 32.9383 105.029 32.5432C105.788 32.1481 106.42 31.5616 106.86 30.8463C107.843 29.3559 108.335 27.1152 108.335 24.1242C108.335 21.1001 107.883 18.8339 106.995 17.318C106.617 16.6034 106.036 16.0078 105.32 15.601C104.604 15.1942 103.782 14.993 102.952 15.0212C102.168 14.9991 101.388 15.1347 100.661 15.4193C99.9628 15.7285 99.3246 16.1506 98.7738 16.6672C98.2217 17.1442 97.7579 17.7087 97.4023 18.3362C97.1013 18.918 96.9517 19.5618 96.9662 20.212L96.9503 26.2909Z" fill="#BFBFBF" />
                  <path d="M121.21 16.4605L121.543 16.5294C122.252 15.6519 123.049 14.8441 123.922 14.1178C124.634 13.5442 125.437 13.0842 126.3 12.755C127.236 12.4213 128.228 12.2578 129.225 12.2727C130.057 12.2681 130.889 12.3141 131.715 12.4105V17.6702H129.035C128.761 17.0014 128.351 16.3923 127.83 15.8787C127.342 15.4818 126.715 15.2793 126.078 15.3121C125.478 15.3207 124.891 15.4875 124.381 15.7944C123.774 16.1677 123.238 16.639 122.796 17.1879C122.336 17.6947 121.971 18.275 121.718 18.9028C121.506 19.5145 121.404 20.1567 121.416 20.8015V28.8098C121.372 29.7737 121.46 30.7392 121.678 31.6808C121.811 32.1547 122.118 32.5657 122.542 32.8369C123.106 33.1317 123.722 33.3238 124.358 33.4034V34.5288H114.844V33.4034C115.288 33.2813 115.72 33.1225 116.136 32.9287C116.401 32.7869 116.631 32.5909 116.81 32.3545C117.037 32.0172 117.183 31.6354 117.238 31.2367C117.348 30.4555 117.394 29.6669 117.373 28.8787V18.9258C117.373 17.9535 117.373 17.1725 117.333 16.5754C117.326 16.081 117.213 15.5935 117 15.1437C116.81 14.8017 116.505 14.5319 116.136 14.3781C115.608 14.161 115.054 14.0092 114.487 13.9264V12.7397L120.037 12.51H121.472L121.21 16.4605Z" fill="#BFBFBF" />
                  <path d="M145.034 34.8886C141.752 34.8886 139.246 33.9571 137.518 32.0942C135.79 30.2312 134.934 27.4674 134.949 23.8027C134.88 21.6013 135.344 19.4147 136.305 17.4175C137.111 15.788 138.414 14.436 140.039 13.5435C141.695 12.6763 143.555 12.2384 145.438 12.2726C148.816 12.2726 151.374 13.222 153.113 15.1207C154.851 17.0194 155.718 19.7449 155.713 23.2973C155.781 25.4979 155.337 27.6853 154.413 29.6978C153.633 31.3396 152.341 32.7048 150.718 33.6024C148.971 34.4984 147.012 34.9415 145.034 34.8886ZM139.397 23.3203C139.397 26.4593 139.926 28.871 140.983 30.5553C141.404 31.3357 142.043 31.9866 142.828 32.4345C143.613 32.8823 144.511 33.1092 145.422 33.0895C146.382 33.1121 147.324 32.8444 148.118 32.3238C148.883 31.8108 149.506 31.1248 149.934 30.3256C150.428 29.4113 150.768 28.4265 150.94 27.4087C151.15 26.2663 151.253 25.1082 151.25 23.9481C151.291 22.059 151.023 20.1754 150.457 18.3668C150.091 17.1093 149.362 15.9782 148.356 15.1054C147.505 14.4248 146.432 14.0561 145.327 14.0641C144.438 14.0388 143.558 14.2494 142.783 14.6733C142.009 15.0971 141.37 15.7179 140.935 16.4681C139.91 18.081 139.397 20.3651 139.397 23.3203Z" fill="#BFBFBF" />
                </g>
                <defs>
                  <clipPath id="clip0_13_624">
                    <rect width="205.979" height="39" fill="white" transform="translate(0.600708)" />
                  </clipPath>
                </defs>
              </svg>
            </Link>
            <div className="d-none d-lg-flex align-items-center flex-nowrap">
              <ul className="navbar-nav flex-row mb-0 me-4">{primaryNavLinks}</ul>
              <ul className="navbar-nav flex-row mb-0">
                <li className="nav-item d-flex align-items-center mx-4">
                  <div>
                    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_18_835)">
                        <path d="M13.0962 9.5H14.7269C14.7269 7.315 12.9006 5.54167 10.6502 5.54167V7.125C12.0037 7.125 13.0962 8.18583 13.0962 9.5ZM16.3576 9.5H17.9882C17.9882 5.56542 14.7024 2.375 10.6502 2.375V3.95833C13.8056 3.95833 16.3576 6.43625 16.3576 9.5ZM17.1729 12.2708C16.1537 12.2708 15.1753 12.1125 14.2622 11.8196C14.1806 11.7958 14.0909 11.78 14.0094 11.78C13.7974 11.78 13.5936 11.8592 13.4305 12.0096L11.6368 13.7513C9.32941 12.6113 7.43784 10.7825 6.26376 8.53417L8.05749 6.78458C8.28578 6.57875 8.35101 6.27 8.26132 5.99292C7.95965 5.10625 7.79658 4.15625 7.79658 3.16667C7.79658 2.73125 7.42968 2.375 6.98125 2.375H4.12759C3.67916 2.375 3.31226 2.73125 3.31226 3.16667C3.31226 10.6004 9.51693 16.625 17.1729 16.625C17.6213 16.625 17.9882 16.2688 17.9882 15.8333V13.0625C17.9882 12.6271 17.6213 12.2708 17.1729 12.2708ZM4.96738 3.95833H6.19038C6.24745 4.655 6.36975 5.34375 6.55728 6.00083L5.57888 6.95875C5.25275 6.00083 5.04076 5.00333 4.96738 3.95833ZM16.3576 15.0179C15.2813 14.9467 14.2377 14.7408 13.2593 14.4162L14.2377 13.4663C14.9307 13.6562 15.6401 13.775 16.3576 13.8225V15.0179Z" fill="#2C2F76" />
                      </g>
                      <defs>
                        <clipPath id="clip0_18_835">
                          <rect width="19.568" height="19" fill="white" transform="translate(0.866211)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="d-flex flex-column ms-2">
                    <p className="mb-0 fs-6-5 bc fw-medium">+92 51 231 433 6</p>
                  </div>
                </li>
                <li className="nav-item ms-1">
                  <>
                    <button
                      className="talk px-4 fw-medium py-2 nav-item fs-6-5 btn btn-primary"
                      type="button"
                      onClick={handleShow}
                    >
                      Let's Talk
                    </button>

                    {/* Modal */}
                    <div
                      className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
                      tabIndex="-1"
                      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                      aria-modal={showModal}
                      role="dialog"
                    >
                      <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: '26%' }}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="btn-close"
                              onClick={handleClose}
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <h5 className="fw-semibold mb-0 bc">Let's Talk</h5>
                              <p className="gc fs-6-5 mb-0 mt-2">We'd love to discuss your project. Fill out the form and our experts will reach out.</p>
                              <p className="gc mb-1 fs-7 mt-4">Name</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Name" />
                              <p className="gc mb-1 fs-7 mt-3">Email</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="your.email@example.com" />
                              <p className="gc mb-1 fs-7 mt-3">Phone</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Phone Number" />
                              <p className="gc mb-1 fs-7 mt-3">Service of Interest</p>
                              <select name="Service" className="w-100 ps-2 custom-input py-2" id="1">
                                <option value="1">Select a service</option>
                                <option value="2">Risk Management</option>
                                <option value="3">Crisis Management</option>
                                <option value="4">Project Support</option>
                                <option value="5">Research & Analysis</option>
                                <option value="6">GIS</option>
                                <option value="7">Cyber Security</option>
                                <option value="8">Training & Capacity Building</option>
                                <option value="9">Digital Solutions</option>
                              </select>
                              <p className="gc mb-1 fs-7 mt-3">Message</p>
                              <div className="mb-3">
                                <textarea className="form-control w-100 custom-input p-2" id="exampleFormControlTextarea1" placeholder="Tell us about your project or inquiry" rows="3"></textarea>
                              </div>
                              <div>
                                <button type="button" className="talk w-100 py-2 fw-medium fs-6-5" onClick={handleClose}>
                                  Submit
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </li>
              </ul>
            </div>

            <button
              className="navbar-toggler d-lg-none"
              type="button"
              onClick={openOffcanvas}
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <OffcanvasMenu
            id="offcanvasNavbar"
            labelledby="offcanvasNavbarLabel"
            show={showOffcanvas}
            onHide={hideOffcanvas}
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                Menu
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={hideOffcanvas}
              ></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav pe-3">
                {primaryNavLinks}
                <li className="nav-item d-flex align-items-center mt-3">
                  <div>
                    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_18_835)">
                        <path d="M13.0962 9.5H14.7269C14.7269 7.315 12.9006 5.54167 10.6502 5.54167V7.125C12.0037 7.125 13.0962 8.18583 13.0962 9.5ZM16.3576 9.5H17.9882C17.9882 5.56542 14.7024 2.375 10.6502 2.375V3.95833C13.8056 3.95833 16.3576 6.43625 16.3576 9.5ZM17.1729 12.2708C16.1537 12.2708 15.1753 12.1125 14.2622 11.8196C14.1806 11.7958 14.0909 11.78 14.0094 11.78C13.7974 11.78 13.5936 11.8592 13.4305 12.0096L11.6368 13.7513C9.32941 12.6113 7.43784 10.7825 6.26376 8.53417L8.05749 6.78458C8.28578 6.57875 8.35101 6.27 8.26132 5.99292C7.95965 5.10625 7.79658 4.15625 7.79658 3.16667C7.79658 2.73125 7.42968 2.375 6.98125 2.375H4.12759C3.67916 2.375 3.31226 2.73125 3.31226 3.16667C3.31226 10.6004 9.51693 16.625 17.1729 16.625C17.6213 16.625 17.9882 16.2688 17.9882 15.8333V13.0625C17.9882 12.6271 17.6213 12.2708 17.1729 12.2708ZM4.96738 3.95833H6.19038C6.24745 4.655 6.36975 5.34375 6.55728 6.00083L5.57888 6.95875C5.25275 6.00083 5.04076 5.00333 4.96738 3.95833ZM16.3576 15.0179C15.2813 14.9467 14.2377 14.7408 13.2593 14.4162L14.2377 13.4663C14.9307 13.6562 15.6401 13.775 16.3576 13.8225V15.0179Z" fill="#2C2F76" />
                      </g>
                      <defs>
                        <clipPath id="clip0_18_835">
                          <rect width="19.568" height="19" fill="white" transform="translate(0.866211)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="d-flex flex-column ms-2">
                    <p className="mb-0 fs-6-5 bc fw-medium">+92 51 231 433 6</p>
                  </div>
                </li>
                <li className="nav-item  mt-3">
                  <>
                    <button
                      className="talk px-4 fw-medium py-2 nav-item fs-6-5 btn btn-primary"
                      type="button"
                      onClick={handleShow}
                    >
                      Let's Talk
                    </button>

                    {/* Modal */}
                    <div
                      className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
                      tabIndex="-1"
                      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                      aria-modal={showModal}
                      role="dialog"
                    >
                      <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: '26%' }}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <button
                              type="button"
                              className="btn-close"
                              onClick={handleClose}
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <h5 className="fw-semibold mb-0 bc">Let's Talk</h5>
                              <p className="gc fs-6-5 mb-0 mt-2">We'd love to discuss your project. Fill out the form and our experts will reach out.</p>
                              <p className="gc mb-1 fs-7 mt-4">Name</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Name" />
                              <p className="gc mb-1 fs-7 mt-3">Email</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="your.email@example.com" />
                              <p className="gc mb-1 fs-7 mt-3">Phone</p>
                              <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Phone Number" />
                              <p className="gc mb-1 fs-7 mt-3">Service of Interest</p>
                              <select name="Service" className="w-100 ps-2 custom-input py-2" id="1">
                                <option value="1">Select a service</option>
                                <option value="2">Risk Management</option>
                                <option value="3">Crisis Management</option>
                                <option value="4">Project Support</option>
                                <option value="5">Research & Analysis</option>
                                <option value="6">GIS</option>
                                <option value="7">Cyber Security</option>
                                <option value="8">Training & Capacity Building</option>
                                <option value="9">Digital Solutions</option>
                              </select>
                              <p className="gc mb-1 fs-7 mt-3">Message</p>
                              <div className="mb-3">
                                <textarea className="form-control w-100 custom-input p-2" id="exampleFormControlTextarea1" placeholder="Tell us about your project or inquiry" rows="3"></textarea>
                              </div>
                              <div>
                                <button type="button" className="talk w-100 py-2 fw-medium fs-6-5" onClick={handleClose}>
                                  Submit
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                </li>
              </ul>
            </div>
          </OffcanvasMenu>
        </nav>
      </div>
    </>
  );
};

export default Hnavbar;
